<template lang='pug'>
	.resources
		v-e24-nav-bar
		headerResources(:srcImage='img', :tall="tall", h1="Title 24 Resources")
		contentResources
		v-e24-footer(:build="build")
</template>

<script>
import headerResources from '@/commonSite/header.vue'
import contentResources from '@/components/resources/content-resources.vue'
import imageHeader from '@/img/resources-header.jpg'
import readBuild from '../util/readBuild'
export default {
	name: 'resources',
	components: {
		headerResources,
		contentResources
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>
<style lang='less'>
</style>



// WEBPACK FOOTER //
// src/views/Resources.vue